import {pageInfo,importData,updateWeight,downtemplate} from './../api';
import {supplierList, plant} from '../../../../api'
import {Message} from 'element-ui';

const purchArrivalPlan = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    supplierObj: [],
    plantObj: [],
    importDataObj: [],
    updateWeightObj : null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    SUPPLIER(state, data) {
      state.supplierObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    UPDATE_WEIGHT(state,data){
      state.updateWeightObj = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async supplier({commit}, obj) {
      let resp = await supplierList(obj);
      commit('SUPPLIER', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async importData({commit}, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    async updateWeight({commit}, obj){
      let resp = await updateWeight(obj);
      commit('UPDATE_WEIGHT', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
  }
}
export default purchArrivalPlan



// WEBPACK FOOTER //
// ./src/page/bd/purchArrivalPlan/store/purchArrivalPlan.store.js